<!--
Author: Liubo
Date: 2018-09-17
Desc: 温馨提示组件
 -->
<template>
    <div v-if="notice.length>0" :class="'view-hint view ' + className">
        <comp-title :title="title" />
        <div class="hint">
            <div class="icon">
                <i class="el-icon-warning" />温馨提示：
            </div>
            <p v-for="(hint,index) in notice" :key="index" class="hint-list" v-html="'<span>'+(notice.length>0?(index+1)+'.':'')+'</span>'+ hint" />
        </div>
    </div>
</template>

<script>
import mixin from "@/assets/js/mixin";
export default {
    name: "Hint",
    mixins: [mixin],
    data () {
        return {
            notice: []
        };
    },
    mounted() {
        this.getNotice();
    },
    methods: {
        getNotice(){
            let _x = "*";
            if(this.data.scenetype === "1"){
                _x = this.$route.query ? (this.$route.query.fundcode || "*") : "*";
            }
            this.$util.request("/common/pagewarmnotice",{routeid: this.data.routeid,scenevalue: _x}).then(res=>{
                if(res.data){
                    if(res.data[0] && res.data[0].content){
                        this.notice = res.data[0].content.split(";");
                    }
                }
            });
        }
    }
};
</script>
<style lang="scss">
    .view-hint {
        .hint {
            padding: 10px 20px;
            .icon {
                line-height: 30px;
                font-size: 16px;
                i {
                    margin-right: 3px;
                }
            }
            .hint-list {
                span{
                    width: 14px;
                    position: absolute;
                    top: 0;
                    left: 0;
                }
                position: relative;
                padding-left: 14px;
                line-height: 24px;
                font-size: 14px;
            }
        }
    }
</style>
